module.exports = __webpack_public_path__ + "static/media/homepage-conflicts.ebdb29f2.webm";